import React, {useEffect, useState} from 'react';
import {isEqual} from 'lodash';

import {isArray, isString} from 'lodash';

import {getClientCity} from 'ultra/configs/general';

import Chip from '@mui/material/Chip';
import Checkbox from '@mui/material/Checkbox';
import {Badge} from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';

import {useConfigStore} from '../../../Stores/config';
import {useToasterStore} from '../../../Stores/toster';
import {useContentStore} from '../../../Stores/content';
import {useFormStore} from '../../../Stores/form';
import DefaultImage from '../../../Modules/Content/Widgets/DefaultImage';
import ContentImage from '../../../Modules/Content/Widgets/ContentImage';

import FilterChip from '../../../Modules/Content/Widgets/FilterChip';
import FilterValue from '../../../Modules/Content/Widgets/FilterValue';

import {hasCityFilterForSource, getFilter} from '../../../Helpers/filters';
import {getNodeByDIDContent} from '../../../Helpers/content';

import './index.scss'

function MyListSubheader(props) {
    const {children} = props;
    return <li {...props}>{children}</li>;
}
MyListSubheader.muiSkipListHighlight = true;

export default function Filter(props) {
    const {size, content, disabled, field, isEditMode, onChange, onBlur} = props;

    const {formVisibleErrors} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];

    const contentStore = useContentStore();
    const {configs} = useConfigStore();
    const {showError} = useToasterStore();

    const {filters} = configs;
    const city = content?._city || getClientCity(window);

    const [open, setOpen] = useState(false);

    // const [elseWasChanged, setElseWasChanged] = useState(false);

    const [value, setValue] = useState(field?.options?.multi ? [] : '')
    const [elseValue, setElseValue] = useState('')
    const [filterInputOpen, setFilterInputOpen] = useState(false)
    const [listFilter, setListFilter] = useState('')
    const [newValue, setNewValue] = useState(field?.options?.multi ? [] : '')
    const [prevValue, setPrevValue] = useState(field?.options?.multi ? [] : '')
    const [preloading, setPreloading] = useState(field.source === "city:chats")
    const [values, setValues] = useState([])
    const [filterConfig, setFilterConfig] = useState()

    const [label, setLabel] = useState(field.required ? field.placeholder + "*" : field.placeholder)
    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

    function filterFormat(filter) {
        if (field?.options?.elseOption) {
            if (!filter.order && filter.values) filter.order = Object.keys(filter.values).sort();
            filter.values = filter.values || {};
            filter.values["_else"] = "Інше";
            if (filter.order && !filter.order.includes("_else")) {
                filter.order = filter.order || [];
                filter.order.push("_else");
            }
        }

        if (field.placeholder) {
            filter.label = field.placeholder;
        }

        return filter
    }

    const getFilterObject = () => new Promise((resolve, reject) => {
        let filter
        if (!field.source) {
            filter = {...field.values};
            resolve(filterFormat(filter));
        }
        else {
            if (field.source === "city:chats") {
                setPreloading(true)
                const chatsDID = configs.content.cities[city].chatsDID;
                getNodeByDIDContent({city, did: chatsDID}, true)
                    .promise
                    .then(config => {
                        filter = {
                            values: {},
                            images: {},
                            // badges: {},
                            order: []
                        }
                        config.children.order.map(id => {
                            if (config.children.list[id].type === "telegram" && !config.children.list[id].not_for_mailing && config.children.list[id]._published) {
                                const chat_id = id.split("\\").pop()
                                filter.order.push(chat_id)
                                filter.values[chat_id] = config.children.list[id].title
                                filter.images[chat_id] = config.children.list[id].thumbnail
                                // filter.values[chat_id] = {
                                //     // TEST:
                                //     // 2 show with image
                                //     image: config.children.list[id].thumbnail,
                                //     label: config.children.list[id].title,
                                // }
                            }
                        })

                        // TEST:
                        // 3 show multiple if needed with search (in popup)
                        setPreloading(false)
                        resolve(filterFormat(filter));
                    })
            }
            else {
                filter = getFilter(filters, city, field.source) || {};
                resolve(filterFormat(filter));
            }
        }
    })

    function getInitValues(filter) {
        const initValues = [];
        if (filter?.order) {
            filter.order.map(id => {
                const item = {
                    id,
                    label: filter.values[id],
                }

                if (filter?.badges?.[id]) {
                    item.badge = filter.badges[id];
                }
    
                if (filter?.images?.[id]) {
                    item.image = filter.images[id]
                }
    
                initValues.push(item)
            })
        }
        else if (filter?.values) {
            Object.keys(filter.values)
                .sort((a, b) => filter.values[a]?.localeCompare(filter.values[b]))
                .map(id => {
                    const item = {
                        id,
                        label: filter.values[id],
                    }
        
                    if (filter?.images?.[id]) {
                        item.image = filter.images[id]
                    }
        
                    initValues.push(item)
                })
        }

        return initValues;
    }

    useEffect(() => {
        let updatedValue
        if (field?.options?.multi) {
            if (getValue()) {
                let tempValue
                try {
                    tempValue = JSON.parse(getValue());
                } catch(e) {
                    tempValue = getValue();
                }

                if (isArray(tempValue)) {
                    updatedValue = tempValue
                }
                else if (isString(tempValue)) {
                    updatedValue = [getValue()]
                }
            }
            else {
                updatedValue = []
            }
        }
        else {
            updatedValue = getValue() || ''
        }

        // if (!isEqual(value, updatedValue))
            setValue(updatedValue);
        // if (!isEqual(newValue, updatedValue)) 
            setNewValue(updatedValue);
        // if (!isEqual(prevValue, updatedValue)) 
            setPrevValue(updatedValue);

        if (field?.options?.elseOption) {
            let updatedElseValue = content[field.id]?.else || "";
            if (!isEqual(elseValue, updatedElseValue)) setElseValue(updatedElseValue);
        }
    }, [content[field.id]])

    useEffect(() => {
        getFilterObject()
            .then(filter => {
                setFilterConfig(filter)

                const initValues = getInitValues(filter);

                if (filter?.label) setLabel(filter.required ? filter.label + "*" : filter.label)

                if (field?.options?.filterByChildren) {
                    const presentFilters = []
                    contentStore?.content?.filters?.[field.id]?.map(childId => {
                        if (!presentFilters.includes(childId)) {
                            presentFilters.push(childId);
                        }
                    })

                    setFilterValues(initValues.filter(filter => presentFilters.includes(filter.id)))
                }
                else {
                    setFilterValues(initValues)
                }
            })
    }, [field])

    const setFilterValues = (v) => {
        let filtered;
        if (field.exclude) {
            filtered = [...v.filter(i => !(field.exclude.includes(i.id)))];
        }
        else {
            filtered = [...v];
        }

        if (field["exclude-if"]) {
            const valuesToExclude = []
            Object.keys(field["exclude-if"]).map(valueToCheck => {
                const parts = field["exclude-if"][valueToCheck].split(",");
                parts.map(j => {
                    const keyValue = j.split("=");
                    const value = content[keyValue[0]]?.else || content[keyValue[0]]?.value || content[keyValue[0]];
                    if (keyValue[1]?.includes(value)) {
                        if (!valuesToExclude.includes(valueToCheck)) {
                            valuesToExclude.push(valueToCheck);
                        }
                    }
                })
            })

            if (valuesToExclude.length > 0) {
                filtered = [...filtered.filter(i => !valuesToExclude.includes(i.id))]
            }
        }

        setValues(filtered);
    }

    const getValue = () => {
        return field?.options?.elseOption ? content[field.id]?.value : content[field.id]
    }

    const onChangeHandler = (e) => {
        e?.stopPropagation()
        setOpen(false)
        setListFilter('')
        setFilterInputOpen(false)

        onChangeWrapper(e)
    }

    const onChangeMultiHandler = (e) => {
        const v = e.target.value

        let updatedValue = [...newValue];
        if (newValue.includes(v)) {
            updatedValue = updatedValue.filter(i => i !== v)
        }
        else {
            if (field?.options?.max && newValue.length === field.options.max) {
                showError({snackbarMessage: `Для поля "${field.placeholder}" ви можете обрати не більше ${field.options.max} значень`})
                return;
            }

            updatedValue.push(v)
        }

        setNewValue(updatedValue);
    }

    const onCloseHandle = (e) => {
        e?.stopPropagation()
        setOpen(false)
        setListFilter('')
        setFilterInputOpen(false)

        setTimeout(() => {
            setNewValue(prevValue);
        }, 200)
    }

    const onApplyHandle = (e) => {
        e?.stopPropagation()
        setOpen(false)
        setListFilter('')
        setFilterInputOpen(false)

        setTimeout(() => {
            onChangeWrapper({target: {value: newValue}})
        }, 200)
    }

    const onClearHandle = (e) => {
        e?.stopPropagation()
        setNewValue([]);
    }

    const onFilterChange = (e) => {
        setListFilter(e.target.value)
    }

    const onDeleteHandle = (item) => {
        let updatedValue = [...newValue];
        const vIndex = updatedValue.indexOf(item);
        if (vIndex > -1) updatedValue.splice(vIndex, 1);
        onChangeWrapper({target: {value: updatedValue.length > 0 ? updatedValue : undefined}});
    }

    const onBlurHandler = (e) => {
        if (field?.options?.elseOption) {
            const v = {
                target: {
                    value: {
                        value: e.target.value,
                        else: e.target.value === "_else" ? elseValue : ""
                    }
                }
            }

            if (e.target.value !== "_else") {
                onBlur(v);
            }
        }
        else {
            onBlur(e);
        }
    }

    const onChangeWrapper = (e) => {
        // setElseWasChanged(false);

        if (field?.options?.elseOption) {
            const v = {
                target: {
                    value: {
                        value: e.target.value,
                        else: e.target.value === "_else" ? elseValue : ""
                    }
                }
            }

            onChange(v);
        }
        else {
            onChange(e);
        }
    }

    if (field?.options?.display === 'chips') {
        return (<div className='FilterChips'>
            {values.map(item => {
                return <Badge
                    key={`filter_chip_${item.id}`}
                    color='primary'
                    badgeContent={item.badge}
                    className={`${item.badge > 0 ? 'newMessages' : ''} ${value === item.id ? 'active' : ''}`}
                >
                    <Chip
                        variant={value === item.id ? 'outlined' : ''}
                        label={item.label}
                        onClick={() => { onChangeWrapper({target: {value: item.id}}) }}
                    />
                </Badge>
                }
            )}
        </div>)
    }

    const onElseChange = (e) => {
        // setElseWasChanged(true);
        const v = {
            target: {
                value: {
                    value: value,
                    else: e?.target?.value
                }
            }
        }

        setElseValue(e?.target?.value)
        onChange(v);
    }

    const onElseBlur = (e) => {
        const v = {
            target: {
                value: {
                    value: value,
                    else: e?.target?.value
                }
            }
        }
        onBlur(v);
    }

    if (preloading) {
        return <div className='SkeletonWithText'>
            <div className='SkeletonWithTextPlaceholder'>Завантажую дані...</div>
            <Skeleton className='FilterField' variant="rectangular" height={56} />
        </div>
    }

    return (<>
        {values?.length > 0 && <FormControl
            fullWidth
            required={field.required}
            error={
                Boolean(
                    (field?.options?.elseOption && value !== '_else')
                    ||
                    (!field?.options?.elseOption)
                )
                && Boolean(showErrorText)
            }
            size={size}
            className={field?.options?.multi ? 'FilterField FilterFieldMulti' : 'FilterField'}
        >
            <InputLabel>{label}</InputLabel>
            <Select
                open={open}
                MenuProps={
                    values?.length > 10 ?
                    // {className: filterInputOpen ? "FilterFieldVerticalMenuPopover FilterFieldVerticalMenuPopoverFilterOpen" : "FilterFieldVerticalMenuPopover"}
                    {className: "FilterFieldVerticalMenuPopover"}
                    : {}
                }
                onBlur={onBlurHandler}
                disabled={isDisabled}
                label={label}
                required={field.required}
                value={value}
                multiple={field?.options?.multi}

                onClick={() => {
                    if (!isDisabled) {
                        setOpen(true);
                    }
                }}

                onClose={onCloseHandle}

                renderValue={(selected) => {
                    if (field?.options?.multi) {
                        return <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((item) => field.source ?
                                <FilterChip
                                    key={'select_chip_' + item}
                                    value={item}
                                    config={field}
                                    deleteIcon={<CloseIcon />}
                                    onDelete={() => onDeleteHandle(item)}
                                />
                                : <Chip
                                    key={'select_chip_' + item}
                                    label={field.values.values[item]}
                                    variant="outlined"
                                    deleteIcon={<CloseIcon />}
                                    onDelete={() => onDeleteHandle(item)}
                                />
                            )}
                        </Box>
                    } else {
                        if (field.source === "city:chats") {
                            return <FilterValue value={selected} config={field} filters={filterConfig}/>
                        }
                        return field.source ?
                            <FilterValue value={selected} config={field} filters={configs?.filters}/>
                            : field.values.values[selected]
                    }
                }}
            >
                <MyListSubheader className='FilterFieldTitle'>
                    {field.placeholder}

                    {values?.length > 10 && <>
                        {filterInputOpen && <CloseIcon
                            className='FilterFieldTitleSearch'
                            onClick={() => {
                                setListFilter('')
                                setFilterInputOpen(!filterInputOpen)
                            }}
                        />}

                        {!filterInputOpen && <SearchIcon
                            className='FilterFieldTitleSearch'
                            onClick={() => {
                                setFilterInputOpen(!filterInputOpen)
                            }}
                        />}

                        {filterInputOpen && <div className="FilterFieldTitleInput">
                            <div className='FilterFieldTitleInputWrap'>
                                <TextField
                                    fullWidth
                                    autoFocus
                                    variant="outlined"
                                    size="small"
                                    onChange={onFilterChange}
                                />
                            </div>
                        </div>
                        }
                    </>}
                </MyListSubheader>

                <MyListSubheader className={`FilterFieldValues ${filterInputOpen && 'FilterFieldValuesOpen'} ${values?.length > 10 && 'FilterFieldValuesHasFilter'}`}>
                    <ul className='FilterFieldValuesList'>
                        {(!field.required && !field?.options?.hasNoEmptyValue) && !field?.options?.multi && <MenuItem
                            value=""
                            key={`${field.id}_empty`}
                            className={newValue.length === 0 ? 'selected' : ''}
                            onClick={(e) => {
                                e.target = {value: ""};
                                onChangeHandler(e)
                            }}
                        >
                            <div className='FilterControlItem'>Всі</div>
                        </MenuItem>}

                        {values
                            .filter(item => {
                                if (listFilter) {
                                    return item.label.toLowerCase().includes(listFilter.toLowerCase())
                                }

                                return true
                            })
                            .map(item =>
                                <MenuItem
                                    key={item.id}
                                    value={item.id}
                                    onClick={(e) => {
                                        e.target = {value: item.id};
                                        field?.options?.multi ? onChangeMultiHandler(e) : onChangeHandler(e)
                                    }}
                                    className={(field?.options?.multi ? newValue.indexOf(item.id) > -1 : item.id === newValue) ? 'selected' : ''}
                                >
                                        <div className='FilterControlItem'>
                                            {field?.options?.multi && <Checkbox checked={newValue.indexOf(item.id) > -1} />}

                                            {field.source === "city:chats" && <ContentImage image={item.image} city={city} className='icon'/>}
                                            {field.source !== "city:chats" && item.image && (hasCityFilterForSource(filters, city, field.source) ?
                                                <ContentImage image={item.image} className='icon'/>
                                                : <DefaultImage image={item.image} className='icon'/>
                                            )}
                                            <span className='text'>{item.label}</span>
                                        </div>
                                </MenuItem>
                        )}
                    </ul>
                </MyListSubheader>

                {/* PSEUDO ELEMENTS: IT'S NEEDED
                BECAUSE MUI SELECT SHOULD HES MenuItem values in root */}
                <MenuItem
                    style={{display: 'none'}}
                    key={`copy_${field.id}_empty`}
                    value=""
                />
                {values.map(item =>
                    <MenuItem
                        style={{display: 'none'}}
                        key={`copy_${item.id}`}
                        value={item.id}
                    />
                )}

                {field?.options?.multi && <MyListSubheader className='FilterFieldSaveButton'>
                    {newValue.length > 0 && <Button variant='outlined' fullWidth onClick={onClearHandle}>Очистити</Button>}
                    {newValue.length === 0 && <Button variant='outlined' fullWidth onClick={onCloseHandle}>Закрити</Button>}
                    <Button variant="contained" fullWidth onClick={onApplyHandle}>Обрати</Button>
                </MyListSubheader>}
            </Select>
            {field?.options?.elseOption && value === '_else' && <div className='FilterElse'>
                <span className='FilterElseIcon'><SubdirectoryArrowRightIcon /></span>
                <TextField
                    className='FilterElseField'
                    error={Boolean(showErrorText)} // field?.required && 
                    // helperText={showErrorText}
                    autoFocus
                    fullWidth
                    value={elseValue}
                    required={field?.required}
                    label={"Інше"}
                    variant="outlined"
                    onChange={onElseChange}
                    onBlur={onElseBlur}
                    disabled={isDisabled}
                />
            </div>}
            {!showErrorText && field?.notes && <div className='fieldNotes'>
                <p>{field?.notes}</p>
            </div>}
            {showErrorText && <div className={`fieldError ${(field?.options?.elseOption && value === '_else') ? "fieldElseError" : "" }`}>{showErrorText}</div>}
        </FormControl>}
    </>)
}
